import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import {
  IFlightAwareResponseViewModel,
  IFlightLocationDetails,
  IFlightRouteResponseModel,
  IGetFlightDataPayloadModel,
  ISaveFlightRoutePayloadModel,
} from '../model/flightTracking.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FlightTrackingService {

  constructor(private httpClient: HttpClient) {}

  getFlightCurrentPositionFromFlightAware(getFlightDataPayload: IGetFlightDataPayloadModel): Observable<IFlightAwareResponseViewModel> {
    const url = `${environment.apiHost}/FlightTracking/GetFlightDetailsFromFlightAware`;

    return this.httpClient
      .post<IFlightAwareResponseViewModel>(url, getFlightDataPayload)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  getFlightRouteFromFlightAware(flightId: string, legId: string): Observable<IFlightRouteResponseModel> {
    const url = `${environment.apiHost}/FlightTracking/GetFlightRouteFromFlightAware/${flightId}/${legId}`;

    return this.httpClient
      .get<IFlightRouteResponseModel>(url)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  getFlightRoute(legId: string): Observable<IFlightLocationDetails[]> {
    const url = `${environment.apiHost}/FlightTracking/GetFlightRoute/${legId}`;

    return this.httpClient
      .get<IFlightLocationDetails[]>(url)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

}
